import React, { Component } from 'react';
import firebaseApp from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Button } from 'reactstrap';
import Events from './Events';
import Event from './Event';
import EventEditor from './EventEditor';
import { isAdmin } from './utils';
import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom';
import { CircleLoader } from 'react-spinners';


console.log(process.env.NODE_ENV);

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authenticated: false,
            authenticating: true,
            loginError: null
        };
        this.componentDidMount = this.componentDidMount.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.logout = this.logout.bind(this);
        this.resetPage = this.resetPage.bind(this);
    }

    componentDidMount() {
        var _this = this;
        const auth = getAuth(firebaseApp);
        onAuthStateChanged(auth, user => {
            if (user) {
                console.log("logged in: " + user.displayName);
                _this.setState({
                    authenticated: true,
                    authenticating: false,
                    loginError: null
                });
            } else {
                console.log("init login check found NO USER, waiting for user action to login");
                _this.setState({
                    authenticated: false,
                    authenticating: false
                });
            }
        });
    }

    handleGoogleLogin() {
        const auth = getAuth(firebaseApp);
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({
            prompt: 'select_account'
        });
        auth.languageCode = 'hu';
        this.setState({ authenticating: true, loginError: null });
        signInWithPopup(auth, provider).catch(error => {
            console.error("Google login failed", error);
            this.setState({
                authenticating: false,
                loginError: error.message
            });
        });
    }

    logout() {
        const auth = getAuth(firebaseApp);
        auth.signOut().then(function() {
            // Sign-out successful.
            console.log("Logout successful.");
            window.location="/";
        }).catch(function(error) {
            // An error happened.
            console.log("Logout failed: " + error);
            window.location="/";
        });
    }

    resetPage() {
        window.location = "/";
    }

    render() {
        const auth = getAuth(firebaseApp);        
        return (
            <Router>
                <div style={{maxWidth: "40rem", margin: "0 auto"}}>
                    <div className="container-fluid h-100 p-5 bg-light border rounded-3">
                        <a onClick={this.resetPage}><img src="/images/pumi_100.png" style={{float:"right"}} /></a>
                        <p className="lead">Pumi, a szervező-kutya!</p>
                        <p>A Pumi összehozza a moziba járókat! Válassz egy eseményt, és jelentkezz rá Te is!</p>
                        
                        <CircleLoader size={100} loading={this.state.authenticating} />

                        {
                            (!this.state.authenticating && !this.state.authenticated) ?
                                <div className="google-login-container">
                                    <p className="lead mb-3">Be kell jelentkezned:</p>
                                    <button
                                        type="button"
                                        className="google-login-button"
                                        onClick={this.handleGoogleLogin}
                                    >
                                        <span className="google-login-button__icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.64 9.2045c0-.6384-.0573-1.2527-.1636-1.841h-7.476v3.481h4.272c-.184 1.0005-.7422 1.8486-1.5803 2.4176v2.0105h2.5554c1.4943-1.3745 2.3925-3.4012 2.3925-5.7681z" fill="#4285F4" />
                                                <path d="M9.9998 18c2.43 0 4.4698-.8064 5.9598-2.1889l-2.5554-2.0105c-.7097.4764-1.6196.7584-2.7044.7584-2.0798 0-3.8405-1.4047-4.4691-3.2915H3.5752v2.0733C5.0562 15.9855 7.3411 18 9.9998 18z" fill="#34A853" />
                                                <path d="M5.5305 11.2675c-.1604-.4764-.2525-.9844-.2525-1.5053s.0921-1.0289.2525-1.5053V6.6836H3.5753c-.513.9975-.8055 2.1229-.8055 3.3786s.2925 2.3812.8055 3.3787l1.9552-1.1734z" fill="#FBBC05" />
                                                <path d="M9.9998 5.8348c1.3217 0 2.5078.4549 3.4411 1.3478l2.581-2.581C14.4657 2.4913 12.426 1.5 9.9998 1.5 7.3411 1.5 5.0562 3.5145 3.5752 6.1464l1.9552 1.5733c.6286-1.8868 2.3893-3.2916 4.4694-3.2916z" fill="#EA4335" />
                                            </svg>
                                        </span>
                                        <span className="google-login-button__text">Bejelentkezés Google fiókkal</span>
                                    </button>
                                    {
                                        this.state.loginError ?
                                            <p className="text-danger mt-3">{this.state.loginError}</p>
                                            : ""
                                    }
                                </div>
                                : ""
                        }

                        {
                            (this.state.authenticated) ?
                                <div>
                                    <Route exact path="/" component={Events}/>
                                    <Route path="/event/:id" component={(props) => (<Event display="long" {...props} />)} />
                                    <Route path="/editevent/:id" component={(props) => (<EventEditor {...props} />)} />
                                </div>
                                : ""
                        }

                        <br/>
                        
                        {isAdmin(auth.currentUser) ?
                            <p>
                                <Link to={{pathname : "/editevent/new"}}>
                                    <Button color="info">Új esemény...</Button>
                                </Link>
                            </p>
                            : "" }

                        {
                            this.state.authenticated ?
                                <p>
                                    <Button onClick={this.logout}>Kijelentkezés</Button>
                                </p>
                                : ""
                        }
                    </div>
                </div>
            </Router>
        );
    }
}

export default App;
